import { CSSProperties, FC } from 'react';
import * as styles from './styles';

const Bar: FC<CSSProperties> = ({ width, height, color }) => {
  return (
    <div css={styles.generateBarStyle({ width, height, backgroundColor: color })}></div>
  );
};

export default Bar;
